/* ================================================================
   MSC SALONS — Header Script
   assets/msc-header.js
   ================================================================ */
(function () {
  'use strict';
  const header  = document.getElementById('msc-header');
  const burger  = document.getElementById('msc-hamburger-btn');
  const closeBtn= document.getElementById('msc-close-btn');
  const menu    = document.getElementById('msc-mobile-menu');
  const backdrop= document.getElementById('msc-menu-backdrop');
  if (!header) return;

  /* Scroll state */
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Mobile menu */
  function openMenu() {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const first = menu.querySelector('a, button');
    if (first) first.focus();
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    burger.focus();
  }
  if (burger)   burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
  });

  /* Focus trap */
  menu.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const els = menu.querySelectorAll('a[href], button:not([disabled])');
    const first = els[0], last = els[els.length - 1];
    if (e.shiftKey) { if (document.activeElement === first) { e.preventDefault(); last.focus(); } }
    else            { if (document.activeElement === last)  { e.preventDefault(); first.focus(); } }
  });
})();
